<template>
  <div class="content-section" v-loading.fullscreen.lock="fullscreenLoading">
    <h2 class="page-title">发票管理</h2>
    <div class="form-row" style="margin-bottom: 10px;">
      <div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          @change="changeTime"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div>
        <el-select v-model="queryParams.InvoiceType" clearable placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="form-group" style="align-self: flex-end;">
        <button class="btn btn-primary" @click="searchBy">查询</button>
      </div>
    </div>
    <el-table
      :data="voiceList"
      height="600"
      v-loading="tableLoading"
      border
      style="width: 100%">
      <el-table-column width="150" align="center" header-align="center" property="F_ContractName" label="合同名称"></el-table-column>
      <el-table-column width="130" align="center" header-align="center" property="F_FileName" label="文件名称">
        <template slot-scope="scope">
          <el-link @click="download(scope.row)" type="primary">{{scope.row.F_FileName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column width="150" align="center" header-align="center" property="F_CompanyName" label="开票名称"></el-table-column>
      <el-table-column width="150" align="center" header-align="center" property="F_CompanyBusNo" label="开票税号"></el-table-column>
      <el-table-column width="100" align="center" header-align="center" property="F_InvoiceType" label="开票类型"></el-table-column>
      <el-table-column width="100" align="center" header-align="center" property="F_InvoicePoint" label="开票点数"></el-table-column>
      <el-table-column width="100" align="center" header-align="center" property="F_InvoiceMoney" label="开票金额"></el-table-column>
      <el-table-column width="150" align="center" header-align="center" property="F_InvoiceProjectName" label="开票项目名称"></el-table-column>
      <el-table-column
        prop="F_AuditStatus"
        align="center"
        header-align="center"
        width="120"
        label="状态">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.F_AuditStatus == 0" size="medium">待设置</el-tag>
          <el-tag type="primary" v-else-if="scope.row.F_AuditStatus == 1" size="medium">已设置</el-tag>
          <el-tag v-else-if="scope.row.F_AuditStatus == 2" size="medium" type="success">已通过</el-tag>
          <el-tag type="danger" v-else-if="scope.row.F_AuditStatus == 3" size="medium">已驳回</el-tag>
          <el-tag type="success" v-else-if="scope.row.F_AuditStatus == 4" size="medium">发票已上传</el-tag>
          <el-tag type="success" v-else-if="scope.row.F_AuditStatus == 5" size="medium">已付款</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="180" align="center" header-align="center" property="F_CreateTime" label="上传时间"></el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        width="100"
        fixed="left"
        label="操作">
        <template slot-scope="scope">
          <button v-if="scope.row.F_AuditStatus == 0 || scope.row.F_AuditStatus == 3" class="btn btn-sm btn-primary" @click="onSet(scope.row)">设置开票</button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="PageSize"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
      :total="total">
    </el-pagination>
    <el-dialog width="500px" center title="开票信息" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="120px">
        <el-form-item label="开票名称">
          <el-input v-model="form.F_CompanyName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票税号">
          <el-input v-model="form.F_CompanyBusNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票类型">
          <el-select v-model="form.F_InvoiceType" clearable placeholder="请选择">
            <el-option
              v-for="(item,index) in optionsType"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票点数">
          <el-input v-model="form.F_InvoicePoint" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票项目名称">
          <el-input v-model="form.F_InvoiceProjectName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveKP">保 存</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: {
          GetPagingInvoice: SZH.assets.api + '/Custom/GetPagingInvoice',
          GetInvoiceForm: SZH.assets.api + '/Custom/GetInvoiceForm',
          SubmitInvoiceForm: SZH.assets.api + '/Custom/SubmitInvoiceForm',
        },
        loading:false,
        queryParams:{
          StartTime:'',
          EndTime:'',
          InvoiceType:2
        },
        options:[
          {label:'入驻费发票',value:1},
          {label:'业务案件发票',value:2},
        ],
        optionsType:[
          {label:'专票',value:'专票'},
          {label:'普票',value:'普票'},
        ],
        PageIndex:1,
        PageSize:20,
        total:0,
        tableLoading:false,
        fullscreenLoading:false,
        dialogFormVisible:false,
        value1:[],
        voiceList:[],
        form:{
          F_Id:'',
          F_CompanyName:'',//开票名称
          F_CompanyBusNo:'',//开票税号
          F_InvoiceType:'',//开票类型（选择：专票/普票）
          F_InvoicePoint:'',// 开票点数
          F_InvoiceProjectName:'',// 开票项目名称
        }
      }
    },
    methods: {
      onSet(row){
        let self = this;
        self.dialogFormVisible = true;
        self.fullscreenLoading = true;
        self.$http.post(self.url.GetInvoiceForm,{
          keyValue:row.F_Id
        })
          .then(result => {
            if (result.state == true) {
              for(let i in self.form){
                self.form[i] = result.data[i]
              }
            } else {
              self.form = {};
              self.$message.error(result.message)
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });

      },
      saveKP(){
        let self = this;
        if(!self.form.F_CompanyName){
          self.$message.error('请输入开票名称');
          return
        }
        if(!self.form.F_CompanyBusNo){
          self.$message.error('请输入开票税号');
          return
        }
        if(!self.form.F_InvoiceType){
          self.$message.error('请选择开票类型');
          return
        }
        if(!self.form.F_InvoicePoint){
          self.$message.error('请输入开票点数');
          return
        }
        if(!self.form.F_InvoiceProjectName){
          self.$message.error('请输入开票项目名称');
          return
        }
        self.fullscreenLoading = true;
        self.$http.post(self.url.SubmitInvoiceForm,self.form)
          .then(result => {
            if (result.state == true) {
              self.$message.success('保存成功!');
              self.dialogFormVisible = false;
              self.searchBy();
            } else {
              self.$message.error(result.message)
            }
            self.fullscreenLoading = false;
          }, () => {
            self.fullscreenLoading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      download(row){
        window.open(SZH.assets.image +'/' + row.F_FileUrl);
      },
      searchBy(){
        this.voiceList = [];
        this.PageIndex = 1;
        this.loadList();
      },
      onSizeChange(val) {
        this.PageSize = val;
        this.loadList();
      },
      onCurrentChange(val) {
        this.PageIndex = val;
        this.loadList();
      },
      changeTime(val){
        if(val && val.length>0){
          this.queryParams.StartTime = val[0];
          this.queryParams.EndTime = val[1];
        }
      },
      loadList(){
        let self = this;
        self.tableLoading = true;
        self.$http.post(self.url.GetPagingInvoice,{
          Data:self.queryParams,
          PageIndex:self.PageIndex,
          PageSize:self.PageSize
        })
          .then(result => {
            if (result.state == true) {
              self.voiceList = result.data.Data;
              self.tableLoading = false;
              self.total = result.data.TotalCount;
            } else {
              self.voiceList = [];
              self.total = 0;
              self.tableLoading = false;
            }
          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('操作失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},
    components: {
    },
    mounted() {
      this.loadList();
    }
  }
</script>

<style scoped>
  .form-row {
    display: flex;
    gap: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/Invoice/Invoice.vue